import { Grid } from '@mui/material';
import React, { useRef, useState } from 'react';
import { CHART_CONTENT_HEIGHT } from '../../../../styles';
import { TableView } from '../../../tableview/TableView';
import { ChartHeader } from '../charts/common/chart-header/ChartHeader';
import { TableViewComponentProps } from './table-view-component-types';

export const TableViewComponent = (props: TableViewComponentProps) => {
  const { fullScreenHandle, titleConfig, displayConfig, tableData } = props;
  const chartContainerRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<HTMLElement>(null);
  const [showTools, setShowTools] = useState(false);
  return (
    <Grid
      item
      container
      ref={chartContainerRef}
      direction="column"
      sx={{ height: '100%' }}
      onMouseEnter={() => setShowTools(true)}
      onMouseLeave={() => setShowTools(false)}
    >
      <ChartHeader
        titleConfig={titleConfig}
        showTools={showTools}
        chartRef={chartRef}
        fullScreenHandle={fullScreenHandle}
        displayConfig={displayConfig}
      />
      <Grid item container sx={{ height: CHART_CONTENT_HEIGHT }}>
        <div
          ref={chartRef as React.LegacyRef<HTMLDivElement>}
          style={{ width: '100%', height: '100%' }}
        >
          <TableView
            tableData={tableData}
            fullScreenHandle={fullScreenHandle}
            chartHeight={CHART_CONTENT_HEIGHT}
          />
        </div>
      </Grid>
    </Grid>
  );
};
